import { IMAGES } from "@/lib/brand";
import { ArrowUpRight } from "lucide-react";

const POSTS = [
  { title: "The Complete Kedarnath Travel Guide",       cat: "Pilgrimage",   read: "8 min", img: IMAGES.heroKedarnath, excerpt: "From Sonprayag to Kedarnath — an honest, gentle guide for first-time pilgrims and returning devotees." },
  { title: "Best Time to Visit Kedarnath",              cat: "Weather",      read: "5 min", img: IMAGES.himalayas,     excerpt: "May, June, September, October — how the mountains behave, and how to plan around it." },
  { title: "Char Dham Packing Checklist",               cat: "Packing",      read: "4 min", img: IMAGES.river,         excerpt: "The essentials, the extras, and what to gracefully leave behind." },
  { title: "Kedarnath Helicopter Guide",                cat: "Helicopter",   read: "6 min", img: IMAGES.drone,         excerpt: "IRCTC bookings, weather cancellations, and choosing the right sector." },
  { title: "Why Choose Sersi for Kedarnath Stay",       cat: "Travel Tips",  read: "4 min", img: IMAGES.cottage,       excerpt: "The advantage of staying near Heritage Aviation Helipad — quieter, closer, calmer." },
  { title: "A Wedding in the Himalayas",                cat: "Weddings",     read: "7 min", img: IMAGES.mandap,        excerpt: "Rituals, weather, décor and the sacred simplicity of a mountain wedding." },
];

export default function Blog() {
  return (
    <div data-testid="page-blog">
      <section className="section-pad pb-12">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12">
          <div className="overline">Journal</div>
          <h1 className="h-display text-[44px] sm:text-[56px] md:text-[72px] lg:text-[88px] font-light mt-6 max-w-5xl tracking-[-0.025em] leading-[1.02]">
            Stories from <span className="italic text-gold">the Himalayas</span>.
          </h1>
          <p className="text-ink-soft mt-8 max-w-lg text-[15px] leading-relaxed">We write for travellers first. Google reads afterwards.</p>
        </div>
      </section>

      {/* Featured post */}
      <section className="max-w-[1500px] mx-auto px-6 md:px-12 pb-16">
        <article className="grid grid-cols-1 md:grid-cols-12 gap-10 items-center group cursor-pointer" data-testid="blog-post-featured">
          <div className="md:col-span-7 img-zoom h-[440px] md:h-[560px]">
            <img src={POSTS[0].img} alt={POSTS[0].title} className="w-full h-full object-cover" />
          </div>
          <div className="md:col-span-5">
            <div className="overline">Featured</div>
            <div className="text-[10px] uppercase tracking-[0.32em] text-ink-mute mt-8">{POSTS[0].cat} · {POSTS[0].read} read</div>
            <h2 className="font-serif-display text-4xl md:text-5xl mt-6 font-light leading-[1.05] tracking-[-0.02em] group-hover:text-gold transition-colors">{POSTS[0].title}</h2>
            <p className="text-ink-soft mt-6 text-[14.5px] leading-relaxed">{POSTS[0].excerpt}</p>
            <a href="/blog" className="link-underline mt-10 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.32em] text-ink" data-testid="blog-featured-cta">Read the Story <ArrowUpRight size={14} /></a>
          </div>
        </article>
      </section>

      <section className="max-w-[1500px] mx-auto px-6 md:px-12 pb-24">
        <div className="border-t border-kc grid grid-cols-1 md:grid-cols-3">
          {POSTS.slice(1).map((p, i) => (
            <article key={i} className="border-b border-kc md:border-b-0 md:border-r border-kc last:border-r-0 py-10 md:p-10 group cursor-pointer" data-testid={`blog-post-${i}`}>
              <div className="img-zoom h-[240px] mb-6"><img src={p.img} alt={p.title} loading="lazy" className="w-full h-full object-cover" /></div>
              <div className="text-[10px] uppercase tracking-[0.32em] text-gold">{p.cat} · {p.read} read</div>
              <h3 className="font-serif-display text-2xl mt-4 font-light leading-tight tracking-[-0.01em] group-hover:text-gold transition-colors">{p.title}</h3>
              <p className="text-ink-soft text-[13.5px] mt-3 leading-relaxed">{p.excerpt}</p>
              <div className="mt-6 text-[11px] uppercase tracking-[0.32em] text-ink flex items-center gap-2">Read <ArrowUpRight size={12} /></div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
